// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClappsQueryVariables = Types.Exact<{
  gameId: Types.Scalars['String']['input'];
  isLoggedIn: Types.Scalars['Boolean']['input'];
}>;


export type ClappsQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, myClapps?: { __typename?: 'CasinoMyVote', id: string, myRating?: Types.RatingEnum }, allClapps?: { __typename?: 'CasinoVotes', id: string, clapps: number } } };

export type MyClappsFragment = { __typename?: 'CasinoMyVote', id: string, myRating?: Types.RatingEnum };

export type ClappsFragment = { __typename?: 'CasinoVotes', id: string, clapps: number };

export const MyClappsFragmentDoc = /*#__PURE__*/ gql`
    fragment MyClappsFragment on CasinoMyVote {
  id
  myRating
}
    `;
export const ClappsFragmentDoc = /*#__PURE__*/ gql`
    fragment ClappsFragment on CasinoVotes {
  id
  clapps: likes
}
    `;
export const ClappsQueryDocument = /*#__PURE__*/ gql`
    query ClappsQuery($gameId: String!, $isLoggedIn: Boolean!) {
  casino {
    id
    myClapps: myVote(gameId: $gameId) @include(if: $isLoggedIn) {
      ...MyClappsFragment
    }
    allClapps: votes(gameId: $gameId) {
      ...ClappsFragment
    }
  }
}
    ${MyClappsFragmentDoc}
${ClappsFragmentDoc}`;
export function useClappsQuery(baseOptions: Apollo.QueryHookOptions<ClappsQuery, ClappsQueryVariables> & ({ variables: ClappsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClappsQuery, ClappsQueryVariables>(ClappsQueryDocument, options);
      }
export function useClappsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClappsQuery, ClappsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClappsQuery, ClappsQueryVariables>(ClappsQueryDocument, options);
        }
export function useClappsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClappsQuery, ClappsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClappsQuery, ClappsQueryVariables>(ClappsQueryDocument, options);
        }
export type ClappsQueryHookResult = ReturnType<typeof useClappsQuery>;
export type ClappsQueryLazyQueryHookResult = ReturnType<typeof useClappsQueryLazyQuery>;
export type ClappsQuerySuspenseQueryHookResult = ReturnType<typeof useClappsQuerySuspenseQuery>;
export type ClappsQueryQueryResult = Apollo.QueryResult<ClappsQuery, ClappsQueryVariables>;